import * as O from "fp-ts/lib/Option.js";

const isPsMaybe = (value, name) =>
  value !== null
  && typeof value === "object"
  && value.constructor?.name === name;

const isNoneLike = (option) =>
  !option
  || O.isNone(option)
  || isPsMaybe(option, "Nothing");

const unwrapSome = (option) => {
  if (O.isSome(option)) {
    return option.value;
  }
  if (isPsMaybe(option, "Just")) {
    return option.value0;
  }
  if (option !== null && typeof option === "object") {
    if (typeof option.value === "string" || typeof option.value === "number" || typeof option.value === "boolean") {
      return option.value;
    }
    if (typeof option.value0 === "string" || typeof option.value0 === "number" || typeof option.value0 === "boolean") {
      return option.value0;
    }
    if (typeof option._0 === "string" || typeof option._0 === "number" || typeof option._0 === "boolean") {
      return option._0;
    }
    if (typeof option._1 === "string" || typeof option._1 === "number" || typeof option._1 === "boolean") {
      return option._1;
    }
  }
  if (option !== null && typeof option !== "object") {
    return option;
  }
  return undefined;
};

export const some = O.some;
export const none = () => O.none;
export const map = (f) => (option) => (isNoneLike(option) ? O.none : O.some(f(unwrapSome(option))));
export const chain = (option) => (next) => (isNoneLike(option) ? O.none : next(unwrapSome(option)));
export const fold = (onNone) => (onSome) => (option) =>
  isNoneLike(option) ? onNone() : onSome(unwrapSome(option));
